
export default function Footer() {
  return (
    <footer id="contact" className="py-16 px-6 lg:px-12 bg-[#042A60]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="/images/KLAR-ki_logo-symbol@2x.png" 
              alt="klar:ki Logo" 
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              KI‑Assistent:innen für mittlere Unternehmen in Österreich – von der Ahnungslosigkeit zur Klarheit.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-base font-medium text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#person" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="/#prozess" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Leistungen
                </a>
              </li>
              <li>
                <a href="/#team" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  KI-Team
                </a>
              </li>
              <li>
                <a href="/faq" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="text-base font-medium text-white mb-4">Kontakt</h4>
            <ul className="space-y-2">
              <li className="text-sm text-white/70">
                klar:ki
              </li>
              <li className="text-sm text-white/70">
                Götzlingstr. 45f, 4040 Pöstlingberg
              </li>
              <li>
                <a href="tel:+4369911413141" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  +43 69911413141
                </a>
              </li>
              <li>
                <a href="mailto:eva@klar-ki.at" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  eva@klar-ki.at
                </a>
              </li>
            </ul>
          </div>

          {/* Rechtliches & Social */}
          <div>
            <h4 className="text-base font-medium text-white mb-4">Folge uns</h4>
            <div className="flex gap-4">
              <a 
                href="https://www.linkedin.com/company/klar-ki" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-xl text-white"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/50">
            © 2025 klar:ki. Alle Rechte vorbehalten.
          </p>
          <a href="/datenschutz" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Datenschutz
                </a>
      
                <a href="/impressum" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">
                  Impressum
                </a>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-white/50 hover:text-white/70 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
